/**
 * useAdminPresets — fetches admin line-item preset rows from /api/price-list
 * and returns them grouped by category, mirroring the shape of the old
 * hardcoded PRESET_SERVICES map.
 *
 * Falls back to whatever `fallback` object is passed in if the API fails,
 * so the form still works if the backend is temporarily unreachable.
 */
import { useEffect, useState } from 'react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export function useAdminPresets(fallback) {
  const [presets, setPresets] = useState(fallback);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const r = await fetch(`${API_URL}/api/price-list`);
        if (!r.ok) return;
        const data = await r.json();
        if (cancelled) return;
        const grouped = {};
        (data.categories || []).forEach(c => {
          const rows = [];
          (c.services || []).forEach(svc => {
            (svc.admin_presets || []).forEach(row => {
              rows.push({
                name: row.label,
                price: Number(row.price) || 0,
                ...(row.note ? { note: row.note } : {}),
              });
            });
          });
          if (rows.length) grouped[c.category] = rows;
        });
        // Preserve "Other" bucket from the fallback so custom rows still work.
        if (fallback && fallback.Other && !grouped.Other) grouped.Other = fallback.Other;
        if (Object.keys(grouped).length) setPresets(grouped);
      } catch (_) { /* keep fallback */ }
    })();
    return () => { cancelled = true; };
  }, []);

  return presets;
}
